import { fetchGet } from './api';
import { IDepartment } from '../types/department.type';

export const fetchDepartments = () => fetchGet<IDepartment[]>('departments');
